<template>
  <AiActionWrapper>
    <template v-slot:content>
      <div>
        <div v-if="!isLoading && !hasError">
          <p class="h6 blue--text text--lighten-1 mb-1">
            {{ $t('ai_features.suggested_solution') }}
          </p>
          <p class="body-2 mb-0" v-html="solutionSuggestion" />
        </div>
        <div v-if="!isLoading && hasError" class="error-container px-3 py-2">
          <div class="d-flex align-center mb-1">
            <v-icon class="mr-1" size="16" color="red lighten-2"
              >mdi-alert-outline</v-icon
            >
            <p class="subtitle-2 font-bold red--text text--lighten-2 ma-0 pa-0">
              {{ $t('ai_features.suggestion_error_title') }}
            </p>
          </div>

          <p class="caption red--text text--lighten-2 mb-1">
            {{ $t('ai_features.summarize_error_message') }}
          </p>
        </div>
        <div class="d-flex justify-center w-100">
          <div
            v-if="isLoading"
            class="d-flex flex-column w-100 justify-center align-center py-8 px-"
          >
            <p class="body-2 blue--text text--lighten-1 mb-1">
              {{ $t('ai_features.generating_solution') }}
            </p>

            <div class="w-100 px-12 py-0">
              <v-progress-linear
                rounded
                class="mt-3"
                color="blue lighten-1"
                height="10"
                model-value="60"
                indeterminate
              ></v-progress-linear>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <v-tooltip top :key="solutionCopied" v-if="!isLoading && !hasError">
        <template v-slot:activator="{ on }">
          <Button
            v-on="on"
            icon="mdi-content-copy"
            size="small"
            :text="$t('common.button.copy_to_clipboard')"
            @click="handleCopyToClipboard"
          />
        </template>
        {{
          solutionCopied
            ? $t('common.copied')
            : $t('ai_features.copy_solution_text')
        }}
      </v-tooltip>
    </template>
  </AiActionWrapper>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '../../mixins/mixin.vue'
import api from '../../api'

import AiActionWrapper from './AiActionWrapper.vue'
import Button from '../UI/Button.vue'
import getEntityId from '../../lib/getEntityId'

const revModelTypes = {
  improvementIdea: 'improvement-ideas',
  problemSolving: 'problem-solving',
  quickAction: 'quick-actions',
}

export default {
  name: 'AiSolution',

  props: {
    rev: Object,
  },

  components: {
    AiActionWrapper,
    Button,
  },

  mixins: [mixin],

  data() {
    return {
      isLoading: false,
      hasError: false,
      solutionCopied: false,
      solutionSuggestion: '',
    }
  },

  mounted() {
    this.fetchSolutionSuggestion()
  },

  computed: {
    ...mapGetters(['organizationId']),

    revType() {
      return this.rev?.entityType ?? this.rev?.type
    },

    revId() {
      return getEntityId(this.rev)
    },
  },

  methods: {
    async fetchSolutionSuggestion() {
      this.isLoading = true
      const { data } = await api.ai.getSolution(
        this.organizationId,
        revModelTypes[this.revType],
        this.revId
      )
      this.solutionSuggestion = data?.suggestion ?? ''
      this.isLoading = false
    },

    handleCopyToClipboard() {
      navigator.clipboard
        .writeText(this.solutionSuggestion)
        .then(() => {
          this.solutionCopied = true
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style scoped lang="scss">
.error-container {
  border: 1px solid $color-red;
  background: rgba(248, 43, 96, 0.2);
  border-radius: 3px;
}
</style>
